
import React from "react";
import styles from "./Etapes.module.css";
import { EtapeTypes } from "@/types/displayData/EtapeTypes";

const EtapesComponent: React.FC<EtapeTypes> = ({ title, subtitle, steps }) => {
  return (
    <section className={styles.etapesContainer}>
      <h2 className={styles.etapesTitle}>{title}</h2>
      <h3 className={styles.etapesSubtitle}>{subtitle}</h3>

      <div className={styles.stepsContainer}>
        {steps.map((step, index) => (
          <div
            key={index}
            className={styles.stepCard}
            style={{ backgroundColor: step.backgroundColor, color: step.textColor }}
          >
            <h4 className={styles.stepNumber}>{step.number}</h4>
            <h5 className={styles.stepTitle}>{step.title}</h5>
            <p className={styles.stepDescription}>{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default EtapesComponent;
